'use client'

import { cn } from '@qr-front/ui/utils'
import * as React from 'react'

export const baseInputCls = (error?: boolean) =>
	cn(
		'type-body-medium h-12 w-full rounded-8 border-none bg-white px-4 ring-1 ring-inset ring-border-grey transition placeholder:text-grey focus:outline-none focus:ring-2 focus:ring-blue disabled:cursor-not-allowed disabled:text-grey [&:not([disabled])]:hover:ring-2',
		error && 'ring-error focus:ring-error',
	)

export type TBaseInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
	containerClassName?: string
	error?: boolean
	leftIcon?: React.ComponentType<{ className?: string }> | null
	rightIcon?: React.ComponentType<{ className?: string }> | null
	rightOnClick?: () => void
	iconSeparator?: boolean
}

export const BaseInput = React.forwardRef<HTMLInputElement, TBaseInputProps>(
	(
		{
			containerClassName,
			className,
			type,
			error,
			leftIcon: LeftIcon,
			rightIcon: RightIcon,
			rightOnClick,
			iconSeparator = true,
			...props
		},
		ref,
	) => {
		const RightElement = rightOnClick ? 'button' : 'div'
		return (
			<div className={cn('relative flex items-center', containerClassName)}>
				{LeftIcon && (
					<div className="pointer-events-none absolute left-4 top-1/2 flex -translate-y-1/2 gap-4 text-grey">
						<LeftIcon className="h-5 w-5" />
						{iconSeparator && (
							<div>
								<div className="h-full border-r border-border-grey-50"></div>
							</div>
						)}
					</div>
				)}
				<input
					type={type}
					className={cn(
						baseInputCls(error),
						'placeholder-shown-ellipsis',
						className,
						LeftIcon && iconSeparator && 'pl-[68px]',
						RightIcon && 'pr-10',
					)}
					ref={ref}
					{...props}
				/>
				{RightIcon && (
					<RightElement
						{...(rightOnClick && {
							onClick: rightOnClick,
							type: 'button',
						})}
						className={cn(
							'absolute right-4 top-1/2 -translate-y-1/2 text-grey',
							!rightOnClick && 'pointer-events-none',
						)}
					>
						<RightIcon className="h-5 w-5" />
					</RightElement>
				)}
			</div>
		)
	},
)
BaseInput.displayName = 'BaseInput'
